(function () {
  if (window.__everSaleCountdownScriptLoaded) return;
  window.__everSaleCountdownScriptLoaded = true;

  var DAY_MS = 24 * 60 * 60 * 1000;
  var CYCLE_DAYS = 2;
  var formatters = {};
  var scriptUrl = document.currentScript && document.currentScript.src;
  var STYLE_URL = scriptUrl ? scriptUrl.replace(/sale-countdown\.js(?=\?|$)/, 'product-art.css') : '';

  function ensureStyles() {
    if (!STYLE_URL || document.querySelector('link[href*="/assets/product-art.css"]')) return;
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = STYLE_URL;
    stylesheet.setAttribute('data-sale-countdown-styles', '');
    document.head.appendChild(stylesheet);
  }

  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function money(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'GBP';
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function numberOnly(cents) {
    return (cents / 100).toLocaleString('en-GB', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function syncProductPricing() {
    var productMatch = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    var root = document.querySelector('[data-wallpaper-crop-root]');
    if (!productMatch || !root) return Promise.resolve();

    var productJsonUrl = '/products/' + productMatch[1] + '.js?ever-sale-sync=' + Date.now();
    return fetch(productJsonUrl, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product pricing request failed.');
        return response.json();
      })
      .then(function (productData) {
        var variantsById = {};
        (productData.variants || []).forEach(function (variant) {
          variantsById[String(variant.id)] = variant;
        });

        root.querySelectorAll('.action-set[data-id]').forEach(function (button) {
          var variant = variantsById[button.getAttribute('data-id')];
          if (!variant) return;
          var compareAt = variant.compare_at_price || variant.price;
          button.setAttribute('data-price', variant.price);
          button.setAttribute('data-compare-at-price', compareAt);

          var paperPrice = button.querySelector('.ever-paper-price');
          if (paperPrice) {
            var onSale = compareAt > variant.price;
            paperPrice.classList.toggle('is-on-sale', onSale);
            paperPrice.textContent = '';
            if (onSale) {
              var compareElement = document.createElement('s');
              compareElement.textContent = money(compareAt);
              paperPrice.appendChild(compareElement);
              paperPrice.appendChild(document.createTextNode(' '));
            }
            var currentElement = document.createElement('span');
            currentElement.textContent = money(variant.price);
            paperPrice.appendChild(currentElement);
            paperPrice.appendChild(document.createTextNode(' / m²'));
          }
        });

        var selectedButton = root.querySelector('.action-set.selected-variant[data-id]');
        var selectedVariant = selectedButton && variantsById[selectedButton.getAttribute('data-id')];
        if (!selectedVariant) selectedVariant = (productData.variants || [])[0];
        if (!selectedVariant) return;

        var selectedCompareAt = selectedVariant.compare_at_price || selectedVariant.price;
        var selectedOnSale = selectedCompareAt > selectedVariant.price;
        var basePrice = root.querySelector('.base_price');
        if (basePrice) {
          basePrice.setAttribute('data-price', selectedVariant.price);
          basePrice.setAttribute('data-compare-at-price', selectedCompareAt);
        }

        var priceSummary = root.querySelector('.ever-price-summary');
        var priceNode = root.querySelector('#prd_price');
        var compareNode = root.querySelector('#prd_compare_price');
        var compareWrapper = root.querySelector('[data-compare-price]');
        if (priceNode) priceNode.textContent = numberOnly(selectedVariant.price);
        if (compareNode) compareNode.textContent = numberOnly(selectedCompareAt);
        if (compareWrapper) compareWrapper.hidden = !selectedOnSale;
        if (priceSummary) {
          var saving = selectedCompareAt - selectedVariant.price;
          var percent = selectedOnSale ? Math.round(saving * 100 / selectedCompareAt) : 0;
          priceSummary.classList.toggle('is-on-sale', selectedOnSale);
          priceSummary.setAttribute('data-sale-percent', percent);
        }
        root.querySelectorAll('[data-order-price]').forEach(function (node) {
          node.textContent = money(selectedVariant.price);
        });
      })
      .catch(function () {
        return undefined;
      });
  }

  function dateParts(date, timeZone) {
    var formatter = formatters[timeZone];
    if (!formatter) {
      formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23'
      });
      formatters[timeZone] = formatter;
    }
    return formatter.formatToParts(date).reduce(function (parts, part) {
      if (part.type !== 'literal') parts[part.type] = parseInt(part.value, 10);
      return parts;
    }, {});
  }

  function dayNumber(year, month, day) {
    return Math.floor(Date.UTC(year, month - 1, day) / DAY_MS);
  }

  function localMidnightUtc(year, month, day, timeZone) {
    var targetAsUtc = Date.UTC(year, month - 1, day, 0, 0, 0);
    var guess = targetAsUtc;
    for (var attempt = 0; attempt < 4; attempt += 1) {
      var parts = dateParts(new Date(guess), timeZone);
      var renderedAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      guess += targetAsUtc - renderedAsUtc;
    }
    return guess;
  }

  function cycleEnd(now, timeZone, anchorDate) {
    var nowParts = dateParts(now, timeZone);
    var anchor = anchorDate.split('-').map(Number);
    var today = dayNumber(nowParts.year, nowParts.month, nowParts.day);
    var anchorDay = dayNumber(anchor[0], anchor[1], anchor[2]);
    var elapsedDays = today - anchorDay;
    var cycleDay = ((elapsedDays % CYCLE_DAYS) + CYCLE_DAYS) % CYCLE_DAYS;
    var targetDayNumber = today + (CYCLE_DAYS - cycleDay);
    var targetDate = new Date(targetDayNumber * DAY_MS);
    return localMidnightUtc(
      targetDate.getUTCFullYear(),
      targetDate.getUTCMonth() + 1,
      targetDate.getUTCDate(),
      timeZone
    );
  }

  function initialise(countdown) {
    if (countdown.getAttribute('data-countdown-initialised') === 'true') return;
    countdown.setAttribute('data-countdown-initialised', 'true');
    var timeZone = countdown.getAttribute('data-time-zone') || 'America/New_York';
    var anchorDate = countdown.getAttribute('data-anchor-date') || '2026-01-01';
    var daysNode = countdown.querySelector('[data-countdown-days]');
    var hoursNode = countdown.querySelector('[data-countdown-hours]');
    var minutesNode = countdown.querySelector('[data-countdown-minutes]');
    var secondsNode = countdown.querySelector('[data-countdown-seconds]');

    function render() {
      var now = new Date();
      var remaining = Math.max(0, cycleEnd(now, timeZone, anchorDate) - now.getTime());
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      if (daysNode) daysNode.textContent = pad(days);
      if (hoursNode) hoursNode.textContent = pad(hours);
      if (minutesNode) minutesNode.textContent = pad(minutes);
      if (secondsNode) secondsNode.textContent = pad(seconds);
      countdown.setAttribute('data-countdown-ready', 'true');
    }

    render();
    window.setInterval(render, 1000);
  }

  function mountFallback() {
    if (document.querySelector('[data-sale-countdown]')) return;
    var template = document.querySelector('template[data-sale-countdown-fallback]');
    var priceSummary = document.querySelector('.ever-price-summary');
    if (!priceSummary) return;
    if (!priceSummary.classList.contains('is-on-sale')) return;
    var salePercent = parseInt(priceSummary.getAttribute('data-sale-percent'), 10);
    if (!salePercent) {
      var compareNode = priceSummary.querySelector('#prd_compare_price');
      var priceNode = priceSummary.querySelector('#prd_price');
      var comparePrice = compareNode ? parseFloat(compareNode.textContent.replace(/,/g, '')) : 0;
      var salePrice = priceNode ? parseFloat(priceNode.textContent.replace(/,/g, '')) : 0;
      if (comparePrice > salePrice) salePercent = Math.round((comparePrice - salePrice) * 100 / comparePrice);
    }
    if (!salePercent) return;
    ensureStyles();
    var countdown;
    if (template && template.content && template.content.firstElementChild) {
      countdown = template.content.firstElementChild.cloneNode(true);
    } else {
      countdown = document.createElement('div');
      countdown.className = 'ever-sale-countdown';
      countdown.setAttribute('data-sale-countdown', '');
      countdown.setAttribute('data-time-zone', 'America/New_York');
      countdown.setAttribute('data-anchor-date', '2026-01-01');
      countdown.setAttribute('aria-label', salePercent + '% off sale countdown, anchored to US Eastern midnight');
      countdown.innerHTML =
        '<div class="ever-sale-countdown__heading">' +
          '<span class="ever-sale-countdown__badge">' + salePercent + '% OFF</span>' +
          '<span class="ever-sale-countdown__title"><i aria-hidden="true"></i>Offer ends in</span>' +
        '</div>' +
        '<div class="ever-sale-countdown__timer" role="timer" aria-live="off">' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-days>00</strong><small>Days</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-hours>00</strong><small>Hrs</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-minutes>00</strong><small>Min</small></span><b aria-hidden="true">:</b>' +
          '<span class="ever-sale-countdown__unit"><strong data-countdown-seconds>00</strong><small>Sec</small></span>' +
        '</div>';
    }
    countdown.setAttribute('data-sale-percent', salePercent);
    countdown.setAttribute('aria-label', salePercent + '% off sale countdown, anchored to US Eastern midnight');
    var badge = countdown.querySelector('.ever-sale-countdown__badge');
    if (badge) badge.textContent = salePercent + '% OFF';
    priceSummary.classList.add('has-sale-countdown');
    priceSummary.insertAdjacentElement('afterend', countdown);
  }

  function start() {
    syncProductPricing().then(function () {
      mountFallback();
      document.querySelectorAll('[data-sale-countdown]').forEach(initialise);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
